module.exports = __webpack_public_path__ + "static/media/ordenesVerde.8e8d054f.png";